import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "email",
  "use": "email-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"email\"><path d=\"M22 2.81H2a2.16 2.16 0 00-2 2.25v13.88a2.16 2.16 0 002 2.25h20a2.16 2.16 0 002-2.25V5.06a2.16 2.16 0 00-2-2.25zm0 1a.87.87 0 01.62.28l-9.5 7.5a1.69 1.69 0 01-2.16 0l-9.5-7.5A.87.87 0 012 3.83zm0 16.34H2a1.14 1.14 0 01-1-1.23V5.1l9.27 7.31a2.7 2.7 0 003.42 0L23 5.1v13.84a1.14 1.14 0 01-1 1.23z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol